import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import IdentityApi from '../../../Api/IdentityApi'
import UserCheck from '../../../Components/UserCheck/UserCheck'
import { Link, useHistory } from 'react-router-dom'
import Page from '../../Page/Page'
import './contest.css'
import Section from '../../../Components/Section/Section'
import ImageBox from '../../../Components/ImageBox/ImageBox'
import { getUserDetailsCookie } from '../../../Api/Utils/apiUtils'
import NotificationBanner from "../../../Components/NotificationBanner/NotificationBanner";
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";


const Contest = () => {
    const [alreadyUser, setalreadyUser] = useState(false)
    const { token } = useParams()
    useEffect(() => {
        const user = getUserDetailsCookie()
        setalreadyUser(user?.id ? true : false)
        IdentityApi.logout()
    }, [])

    const history = useHistory()
    function redirectToSignup(isExistingUser) {
        if (isExistingUser) {
            history.push('/login', {params:token})
        }else{
            history.push('/register', {params:token})
        }
    }
    
    return (
        <Page>
            <Section customClass='contest-section'>
                <Container>
                    <div className="contestbox">
                        <div className="contest-information">
                            <h2>Enter Elite Partyz 2k giveaway!</h2>
                            <h3>Enter Elite Partyz 2k giveaway!</h3>
                            <div className="barr"></div>
                            <p>Enter your details for the chance to win Elite Partyz 2k wedding giveaway at the Melbourne Bridal and Wedding Expo. One lucky couple will win this incredible prize including $1k to spend on either a mobile bar or catering. $500 on an incredible photobooth thanks to our two major sponsors.<br /><br />
                            Enjoy a $150 voucher when you spend $800 on wedding favors, $150 off a cake for either your pre-wedding events or your actual wedding. Spoil yourself with 40% storewide from Melbourne's leading spiritual retailer.</p>
                            <Link to="/contest-trems">
                                Contest terms and conditions.
                            </Link>
                        </div>
                        <UserCheck isDisable={alreadyUser} buttonHandle={redirectToSignup} />
                    </div>
                    <div className="img-container">
                        <ImageBox src={'../img/c1.jpg'} />
                        <ImageBox src={'../img/nc3.jpg'} />
                        <ImageBox src={'../img/nc2.jpg'} />
                        <ImageBox src={'../img/nc5.jpg'} />
                        <ImageBox src={'../img/nc4.jpg'} />
                    </div>
                </Container>
            </Section>
        </Page>
    )
}

export default Contest